<template>
    <div style="display: flex;align-items: center;padding: 2px 10px 0px 10px;justify-content: center;">
        <el-dropdown @command="handleCommand">
            <div style="font-size: 12px;font-weight: bold;">
              {{ languages.find(item => item.value == currentLanguage)?.name }}
            </div>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item v-for="item in languages" :command="item.value" :key="item.value"
                        :disabled="currentLanguage === item.value">
                        <span>{{ item.name }}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
<script>
import { getDictByKey } from '@/utils/dict';
import { defineComponent, reactive, toRefs, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import useAppStore from '../../store/modules/app'
import { ElMessage } from 'element-plus'
export default defineComponent({
    setup() {
        const i18n = useI18n()
        const appStore = useAppStore()
        const state = reactive({
            languages: [
                {
                    name: '中文简体',
                    value: 'zh'
                },
                {
                    name: '中文繁體',
                    value: 'zhTw'
                },
                {
                    name: 'EN',
                    value: 'en'
                },
                {
                    name: 'th',
                    value: 'th'
                },
            ]
        })

        async function initField() {
            const rows = await getDictByKey("sys_i18n_language_config");
            state.languages = [];
            rows.forEach(item => {
                state.languages.push({
                    name: item.dictLabel,
                    value: item.dictValue
                })
            })
        }

        const currentLanguage = computed(() => {
            return appStore.locale;
        })

        //command用法很简单,绑定在el-dropdown-item标签的"zh"值和"en",让其发生变化时候做出其他操作,类似监听标签属性
        //和在便签中定义函数传参类似的
        const handleCommand = (val) => {
            //command获取值切换语音
            appStore.SET_LOCALE(val);
            i18n.locale.value = val;
        };

        onMounted(() => {
            initField();
        })

        return {
            ...toRefs(state),
            currentLanguage,
            handleCommand
        }
    }
})
</script>

